import type { VideochatDetailsApi } from 'api-typings/messages/messages_types';
import type { Videochat } from './videochats.model';

export function transformVideochats(videochat: VideochatDetailsApi): Videochat {
  return {
    id: videochat.videochat_id,
    callerUserId: videochat.caller_user_id,
    receiverUserId: videochat.receiver_user_id,
    threadId: videochat.thread_id,
    endReason: videochat.end_reason,
    startTime: videochat.start_time,
    endTime: videochat.end_time,
  };
}
